import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React,{useState} from 'react';
import DeleteProjectConfirm from '../../pages/ProjectView/DeleteProjectConfirm';
const DeleteBtn = (props) => {
  const statusList  = ['In Service','Archived']
  const [confirm,setConfirm] = useState(false)

return (
  <>
 {statusList.includes(props?.data?.appStatusGroup)? <>-</> :
    <span onClick={props.onClick?()=>props.onClick():()=>setConfirm(true)}>
      <FontAwesomeIcon icon={['fas', 'trash-alt']} size="sm" />
    </span>
  }
  <DeleteProjectConfirm prjData ={props?.data} confirm={confirm} setConfirm={setConfirm} />
  </>
)
};

export default DeleteBtn;
